import { render, staticRenderFns } from "./NotificationViewModal.vue?vue&type=template&id=5fb4c3d4&"
import script from "./NotificationViewModal.vue?vue&type=script&lang=js&"
export * from "./NotificationViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports